import { render, staticRenderFns } from "./CreateTopOfWeek.vue?vue&type=template&id=4ff6e739&"
import script from "./CreateTopOfWeek.vue?vue&type=script&lang=ts&"
export * from "./CreateTopOfWeek.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTopOfWeek.vue?vue&type=style&index=0&id=4ff6e739&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports